export enum ConnectionType {
    Coach = "Coach",
}
